// progress
import Progress from "../../../components/progress/progress";
// hook
import { useEffect, useState } from "react";
// @ts-ignore
import Cookies from "js-cookie";
// form
import { useForm } from 'react-hook-form';
// toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toastOptions } from "../../../features/toast/toast";
// routes
import { routes } from "../../../features/routes/route";
// navigate
import { NavLink, useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { nationalCart } from "../../../services/auth/nationalCart/nationalCart";
import { SetUser } from "../../../services/auth/userInfo/setUser";
import Loading from "../../../components/loading/loading";

const ThirdStep = () => {
    const { register, handleSubmit, watch }: any = useForm<any>({});
    const navigate = useNavigate();
    let [user, setUser] = useState(Cookies.get('user'))

    const watchedItems = watch();
    const allChecked = ['item1', 'item2', 'item3', 'item4', 'item5', 'item6', 'item7', 'item8'].every(
        (key) => watchedItems?.[key] === true
    );

    const UserMutation = useMutation({
        mutationFn: SetUser,
        onSuccess: data => {
            Cookies.set("fatherName", data?.fatherName ? data?.fatherName : 'بدون اطلاعات');
            Cookies.set("identificationNo", data?.identificationNo);
            let birth = Cookies.get('birthDay');
            const cleanedDate = birth.replace(/\//g, "");
            let dataNew: any = {
                nationalCode: Cookies.get('nationalCode'),
                birthDate: cleanedDate,
                phoneNumber: Cookies.get('mobileNumber'),
            }
            CartMutation.mutate(dataNew);
        },
        onError: (error: any) => {
            toast.error(error?.response?.data?.message, toastOptions);
        },
    });
    const CartMutation = useMutation({
        mutationFn: nationalCart,
        onSuccess: data => {
            if (data?.image) {
                localStorage.setItem('userImage', data?.image)
                navigate(routes.auth[3].address)
            }
        },
        onError: (error: any) => {
            toast.error(error?.response?.data?.message, toastOptions);
        },
    });

    const onSubmit = (data: any) => {
        const hasFalseValue = Object.values(data).some(value => value === false);
        if (hasFalseValue) {
            toast.error('لطفا تمامی موارد را به درستی انتخاب نمایید. ', toastOptions);
        } else {
            let birth = Cookies.get('birthDay');
            const cleanedDate = birth.replace(/\//g, "");
            let data: any = {
                nationalCode: Cookies.get('nationalCode'),
                birthDate: cleanedDate,
                phoneNumber: Cookies.get('mobileNumber'),
            }
            UserMutation.mutate(data);
        }
    };

    useEffect(() => {
        setUser(Cookies.get('user'));
    }, [])
    return (
        <>
            {UserMutation.isPending || CartMutation.isPending ? (
                <div
                    style={{ height: "100dvh" }}
                    className="d-flex h-100 align-items-center justify-content-center"
                >
                    <Loading />
                </div>
            ) : (
                <>
                    <Progress number={2} />
                    {user ? (
                        <section className={'container pb-3'}>
                            <div className={'row justify-content-center'}>
                                <div className={'col-lg-6 col-md-7 col-12'}>
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <h1 className={'h2 fw-bold text-white text-center'}>
                                            تایید اطلاعات
                                        </h1>
                                        <h6 className={'font-medium mt-4 fw-bold text-white text-center'}>
                                            روی هر کدوم از اطلاعاتی که درستن کلیک کنین تا زرد بشن
                                        </h6>
                                        <div className={'my-4'}>
                                            <input
                                                {...register('item1')}
                                                id="item2"
                                                className={'form-check-input'} type="checkbox" />
                                            <label htmlFor="item2" className={'form-control blue-bg px-4'}>
                                                <div className={'d-flex align-items-center justify-content-between h-100'}>
                                                    <p className={'dark-green mb-0 font-medium-lg'}>نام و نام خانوادگی:</p>
                                                    <p className={'dark-green mb-0 font-medium-lg'}>
                                                        {Cookies.get('name')}
                                                    </p>
                                                </div>
                                            </label>
                                        </div>
                                        <div className={'my-4'}>
                                            <input
                                                {...register('item2')}
                                                id="item3"
                                                className={'form-check-input'} type="checkbox" />
                                            <label htmlFor="item3" className={'form-control blue-bg px-4'}>
                                                <div className={'d-flex align-items-center justify-content-between h-100'}>
                                                    <p className={'dark-green mb-0 font-medium-lg'}>تاریخ تولد:</p>
                                                    <p className={'dark-green mb-0 font-medium-lg'}>
                                                        {Cookies.get('birthDay')}
                                                    </p>
                                                </div>
                                            </label>
                                        </div>
                                        <div className={'my-4'}>
                                            <input
                                                {...register('item3')}
                                                id="item4"
                                                className={'form-check-input'} type="checkbox" />
                                            <label htmlFor="item4" className={'form-control blue-bg px-4'}>
                                                <div className={'d-flex align-items-center justify-content-between h-100'}>
                                                    <p className={'dark-green mb-0 font-medium-lg'}>کدملی:</p>
                                                    <p className={'dark-green mb-0 font-medium-lg'}>
                                                        {Cookies.get('nationalCode')}
                                                    </p>
                                                </div>
                                            </label>
                                        </div>
                                        <div className={'my-4'}>
                                            <input
                                                {...register('item4')}
                                                id="item5"
                                                className={'form-check-input'} type="checkbox" />
                                            <label htmlFor="item5" className={'form-control blue-bg px-4'}>
                                                <div className={'d-flex align-items-center justify-content-between h-100'}>
                                                    <p className={'dark-green mb-0 font-medium-lg'}>نام بانک:</p>
                                                    <p className={'dark-green mb-0 font-medium-lg'}>
                                                        {user?.bankName}
                                                        {Cookies.get('bankName')}
                                                    </p>
                                                </div>
                                            </label>
                                        </div>
                                        <div className={'my-4'}>
                                            <input id="item6"
                                                {...register('item5')}
                                                className={'form-check-input'} type="checkbox" />
                                            <label htmlFor="item6" className={'form-control blue-bg px-4'}>
                                                <div className={'d-flex align-items-center justify-content-between h-100'}>
                                                    <p className={'dark-green mb-0 font-medium-lg'}>شماره حساب:</p>
                                                    <p className={'dark-green mb-0 font-medium-lg'}>
                                                        {Cookies.get('depositNumber')}
                                                    </p>
                                                </div>
                                            </label>
                                        </div>
                                        <div className={'my-4'}>
                                            <input
                                                {...register('item6')}
                                                id="item7"
                                                className={'form-check-input'} type="checkbox" />
                                            <label htmlFor="item7" className={'form-control blue-bg px-4'}>
                                                <div className={'d-flex align-items-center justify-content-between h-100'}>
                                                    <p className={'dark-green mb-0 font-medium-lg'}>شماره کارت:</p>
                                                    <p className={'dark-green mb-0 font-medium-lg'}>
                                                        {Cookies.get('number')}
                                                    </p>
                                                </div>
                                            </label>
                                        </div>
                                        <div className={'my-4'}>
                                            <input
                                                {...register('item7')}
                                                id="item8" className={'form-check-input'} type="checkbox" />
                                            <label htmlFor="item8" className={'form-control blue-bg px-4'}>
                                                <div className={'d-flex align-items-center justify-content-between h-100'}>
                                                    <p className={'dark-green mb-0 font-medium-lg'}>شماره شبا:</p>
                                                    <p className={'dark-green mb-0 font-medium-lg'}>
                                                        {Cookies.get('iban')}
                                                    </p>
                                                </div>
                                            </label>
                                        </div>
                                        <div className={'my-4'}>
                                            <input
                                                {...register('item8')}
                                                id="item9" className={'form-check-input'} type="checkbox" />
                                            <label htmlFor="item9" className={'form-control blue-bg px-4'}>
                                                <div className={'d-flex align-items-center justify-content-between h-100'}>
                                                    <p className={'dark-green mb-0 font-medium-lg'}>نام معرف</p>
                                                    <p className={'dark-green mb-0 font-medium-lg'}>
                                                        {Cookies.get('refName_new') !== "null" ? Cookies.get('refName_new') : 'بدون معرف'}
                                                    </p>
                                                </div>
                                            </label>
                                        </div>
                                        <div className={'d-flex justify-content-between mt-3'}>
                                            <NavLink
                                                className={'btn form-btn back-btn rounded rounded-pill text-site px-4'}
                                                to={routes.auth[1].address}>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M15.85 8.99004C18.72 10.65 18.72 13.36 15.85 15.02L13.54 16.36L11.23 17.7C8.35 19.34 6 17.99 6 14.67V12V9.33004C6 6.02005 8.35 4.66005 11.22 6.32005"
                                                        stroke="#31A59D" strokeWidth="2" strokeMiterlimit="10"
                                                        strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                                مرحله قبل
                                            </NavLink>
                                            <button type={'submit'}
                                                disabled={!allChecked || UserMutation.isPending}
                                                className={'btn form-btn fw-bold rounded rounded-pill p-2 px-4'}>
                                                {UserMutation.isPending ? (<>
                                                    در حال ارسال
                                                </>) : 'ادامه'}
                                                {UserMutation.isPending ? (<>
                                                    <span className="spinner-border spinner-border-sm ms-2"></span>
                                                </>) : (
                                                    <>
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </section>
                    ) : (<></>)}
                    <ToastContainer />
                </>
            )
            }
            <ToastContainer />
        </>
    );
};


export default ThirdStep;
